import { toast } from "sonner";
import request from "./../../../helpers/request";

export const getDocumentacaoAVCB = async (
  idLoja: number,
  idRegional: number
) => {
  const url = `${process.env.REACT_APP_API}/DocumentacaoAVCB/GetAllByLojaRegional/?idLoja=${idLoja}&idRegional=${idRegional}`;
  const result = await request({ url, method: "GET" });

  if (result.status === 200) {
    return result.data;
  } else {
    toast.error("Falha ao obter os arquivos.");
    throw new Error(
      result.data?.message || "Erro desconhecido ao enviar os arquivos."
    );
  }
};
